<template>
	<router-link
			:to="{ name: to }"
			:title="label"
			class="nav-item"
			:exact="exact"
	>
		<span class="nav-icon">
			<i :class="iconName"></i>
		</span>
		<span class="nav-label" v-text="label" />
		<span v-if="alerts" v-text="alerts" class="nav-alert tag is-primary" />
	</router-link>
</template>

<script>
export default {
  name: 'Link',
  props: {
    to: {
      type: String,
      default: '#'
    },
    label: {
      type: String,
      default: '#'
    },
    icon: {
      type: String,
      default: 'unknown'
    },
    alerts: {
      type: Number,
      default: 0
    }
  },
  computed: {
    iconName () {
      return `fas fa-${this.icon}`
    },
    exact () {
      return this.to === 'dashboard'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Nav/Link.vue